import { TemplatePage } from './types';

const fashionPage: TemplatePage = {
  header: {
    color: '#FFCA6C',
    icon: 'images/video-templates/fashion.jpg',
    title: 'Fashion Video Templates Collection',
    title_meta: '50+ Free and Customizable Fashion Video Templates',
    description_meta:
      'Get a kit of eye-catching trendy video templates crafted for the fashion industry. Over 50 customizable ' +
      'templates to make your videos hip and shiny.',
    description:
      'Classy, casual or provocative, these templates are designed to highlight your ultimate sense of style. Become ' +
      'a trendsetter with a collection of fashion video templates that are easy to customize and ready to inspire.'
  },
  footer: {
    category: 'Fashion',
    description:
      'Video production is a breeze with Wave.video’s rich collection of customizable templates. Tweak the colors, ' +
      'swap the footage and customize the message – your very own video is good to go. Video templates are your best ' +
      'shortcut to neat and beautiful video content.'
  },
  content: [
    {
      type: 'templates',
      title: 'Fashion Video Templates',
      search: { category: '/Industries/Fashion & Beauty' }
    },
    {
      type: 'stocks',
      title: 'fashion',
      search: { name: 'fashion' }
    },
    { type: 'calendar' }
  ]
} as TemplatePage;

export default fashionPage;
